(() => {
  let sectionType = "search";
  const isCollectionsPath = location.pathname.includes("/collections");
  if (isCollectionsPath) sectionType = "main-collection";

  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  //Close all filter groups except the element that is passed as an argument (if it is passed) otherwise close all dropdowns
  const closeAllFilterGroups = (except = null) => {
    qsa(".filter-group.open").forEach((group) => {
      if (group === except) return;
      group.classList.remove("open");
      group.querySelector("[data-filter-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      group.querySelector(".filter-group__options")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });
  };

  //Close all sort groups except the element that is passed as an argument (if it is passed) otherwise close all dropdowns
  const closeAllSortGroups = (except = null) => {
    qsa(".sort-group.open").forEach((group) => {
      if (group === except) return;
      group.classList.remove("open");
      group.querySelector("[data-sort-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      group.querySelector("[data-sort-options]")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });
  };

  //Get checked Filters, returns array of elements like this: {name: 'filter.p.m.custom.merk', value: 'Dymo'}
  const getCheckedFilters = () =>
    qsa('[data-filters-form] input[type="checkbox"]:checked').map((checkbox) => ({
      name: checkbox.name.endsWith("[]") ? checkbox.name.slice(0, -2) : checkbox.name,
      value: checkbox.value,
    }));

  //Get currently selected Sort value, example: "best-selling"
  const getSortValue = () => {
    // prefer any explicit sort_by hidden input; they should be in sync
    const inp = document.querySelector(
      '[data-filters-form] input[name="sort_by"]'
    );
    return inp ? inp.value : "";
  };

  //when user sort elements, this function update both mobile and desktop sort input fields value (because there is mobile and desktop sort input)
  const setSortValueEverywhere = (value) => {
    let inputs = document.querySelectorAll('input[name="sort_by"]');
    if (inputs) {
      inputs.forEach((inp) => {
        if (inp) inp.value = value;
      });
    }
  };

  // We have mobile and desktop filter form with checkboxes. Once user select something on desktop, this function select it on mobile as well, and vice versa.
  // use CSS.escape because filter value can be filter.p.m.custom.merk or have similar characters or spaces (, . / [] {} %^&* ... ). This creates a string to use without issues
  const selectSameCheckboxesAcrossDevices = (name, value, checked) => {
    qsa(
      `[data-filters-form] input[type="checkbox"][name="${CSS.escape(
        name
      )}"][value="${CSS.escape(value)}"]`
    ).forEach((el) => {
      el.checked = checked;
    });
  };

  // Built query params out of filters or sort
  const buildQueryParams = (page = 1) => {
    const params = new URLSearchParams();

    // get filters, getCheckedFilters returns array of theese: { name: "filter...merk", value: "Dymo" } and if there are duplicates map removes duplicates
    const pairs = Array.from(
      new Map(getCheckedFilters().map(p => [`${p.name}-${p.value}`, p])).values()
    );
    pairs.forEach(({ name, value }) => params.append(name, value));

    // get sort
    const sortVal = getSortValue();
    if (sortVal) params.append("sort_by", sortVal);

    // get page
    params.append("page", String(page));

    return params;
  };

  //Collection Layout Desktop Changes, once you click on button, remove collection__layout-1/2/3 classes from products grid and add the class of currently selected button
  function handleDesktopLayout() {    
    const layoutButtons = document.querySelectorAll(".collection__layout-type");
    const productsWrapper = document.querySelector(
      ".collection__products-wrapper"
    );

    layoutButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const layout = button.dataset.layout;

        productsWrapper.classList.remove(
          "collection__layout-1",
          "collection__layout-2",
          "collection__layout-3"
        );

        productsWrapper.classList.add(`collection__layout-${layout}`);
        productsWrapper.dataset.layout = layout;

        layoutButtons.forEach((btn) => btn.removeAttribute("aria-current"));
        button.setAttribute("aria-current", "true");
      });
    });
  }

  //Get selected Filter and return it as an object
  function getSelectedFilters() {
    const form = document.querySelector(".FiltersFormDesktop");
    if (!form) return [];

    const checkedInputs = Array.from(
      form.querySelectorAll('input[type="checkbox"]:checked')
    );

    return checkedInputs.map((input) => {
      // find labelu based on attribute
      let labelText = "";
      if (input.id) {
        const label = form.querySelector(`label[for="${input.id}"]`);
        if (label) {
          labelText = label.textContent.trim();
        }
      }

      return {
        input, // input element
        name: input.name, //  "filter.p.m.custom.merk"
        value: input.value, //  "Dymo"
        label: labelText, //  "Dymo" if exist label
      };
    });
  }

  // Clear filters and re-render product grid
  document.addEventListener("click", (e) => {
    const clearBtn = e.target.closest("[data-clear-filters]");
    if (!clearBtn) return;

    e.preventDefault();
    qsa('[data-filters-form] input[type="checkbox"]').forEach(
      (cb) => (cb.checked = false)
    );
    applyFilters(1, false);
  });

  // Filter dropdown toggle. 
  document.addEventListener("click", (e) => {
    const filterToggle = e.target.closest("[data-filter-toggle]");
    if (filterToggle) {
      const group = filterToggle.closest("[data-filter-group]");

      //close all filters and sort dropdowns
      // closeAllFilterGroups(group);
      closeAllSortGroups();

      const isOpen = group.classList.toggle("open");

      //calculate bottom position of this button and create CSS variable. We need it for overlay of filters on mobile (height: calc(100% - this css variable))
      let filterHeight = group.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty(
        "--filter-bottom-position",
        `${parseInt(filterHeight)}px`
      );

      //block body scroll on mobile
      if (window.innerWidth < 768) {
        if (document.body.classList.contains("overflow-hidden")) {
          document.body.classList.remove("overflow-hidden");
        } else {
          document.body.classList.add("overflow-hidden");
        }
      }

      //add aria-expanded
      filterToggle.setAttribute("aria-expanded", String(isOpen));

      //set aria-hidden
      group
        .querySelector(".filter-group__options")
        ?.setAttribute("aria-hidden", String(!isOpen));
      return;
    }    
  });

  // Sort dropdown toggle
  document.addEventListener("click", (e) => {
    const sortToggle = e.target.closest("[data-sort-toggle]");
    if (sortToggle) {
      const group = sortToggle.closest("[data-sort-group]");

      closeAllSortGroups(group);
      // closeAllFilterGroups();

      const isOpen = group.classList.toggle("open");
      sortToggle.setAttribute("aria-expanded", String(isOpen));
      group
        .querySelector("[data-sort-options]")
        ?.setAttribute("aria-hidden", String(!isOpen));
      return;
    }
    if (!e.target.closest("[data-sort-group]")) {
      qsa(".sort-group.open").forEach((group) => {
        group.classList.remove("open");
        group.querySelector("[data-sort-toggle]")?.setAttribute(
          "aria-expanded",
          "false"
        );
        group.querySelector("[data-sort-options]")?.setAttribute(
          "aria-hidden",
          "true"
        );
      });
    }
  });

  // add event listner on button for closing filters on mobile (close button)
  function handleMobileCloseFilters() {
    let closeMobileFiltersButton = document.querySelector(
      ".close-mobile-filters"
    );

    if (closeMobileFiltersButton) {
      closeMobileFiltersButton.addEventListener("click", () => {
        closeMobileFilters(closeMobileFiltersButton);
      });
    }
  }

  //actually close filters on mobile
  function closeMobileFilters(closeMobileFiltersButton) {
    const group = closeMobileFiltersButton.closest("[data-filter-group]");
    group.classList.remove("open");        
    document.body.classList.remove("overflow-hidden");        
  }

  // Click on sort take value and update both sort mobile and desktop. Then re-render section
  document.addEventListener("click", (e) => {
    const sortOption = e.target.closest(".sort-group__option");
    if (!sortOption) return;

    const value = sortOption.dataset.sortValue || "";

    // Update hidden inputs + labels everywhere
    setSortValueEverywhere(value);    

    // Close all sort dropdowns
    qsa(".sort-group.open").forEach((group) => {
      group.classList.remove("open");
      group.querySelector("[data-sort-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      group.querySelector("[data-sort-options]")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });

    applyFilters(1, false);
  });

  // Prevent native submit
  document.addEventListener("submit", (e) => {
    if (!e.target.matches("[data-filters-form]")) return;
    e.preventDefault();
    applyFilters(1, false);
  });


  const isDesktop = () => window.innerWidth >= 768;
  let lastAppliedFiltersState = null;

  // Read current state
  const getFiltersState = () => {
    const state = {};
    const allInputs = document.querySelectorAll('[data-filters-form] input[type="checkbox"]');

    allInputs.forEach((cb) => {
      const key = `${cb.name}:::${cb.value}`;
      state[key] = cb.checked;
    });

    return state;
  };

  // return checkbox to saved state (If user cancel and does not apply filters on mobile)
  const restoreFiltersState = (state) => {
    if (!state) return;

    const allInputs = document.querySelectorAll('[data-filters-form] input[type="checkbox"]');

    allInputs.forEach((cb) => {
      const key = `${cb.name}:::${cb.value}`;

      if (Object.prototype.hasOwnProperty.call(state, key)) {
        cb.checked = state[key];
      } else {      
        cb.checked = false;
      }
    });
  };

  // change filter
  document.addEventListener("change", (e) => {
    const cb = e.target;
    if (!cb.matches('[data-filters-form] input[type="checkbox"]')) return;
    
    selectSameCheckboxesAcrossDevices(cb.name, cb.value, cb.checked);
    
    if (!isDesktop()) return;

    //desktop immediately apply filters
    applyFilters(1, false);
    //after applying set to be current state
    lastAppliedFiltersState = getFiltersState();
  });

  // Apply button on moible. 
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".filter-mob-apply");
    if (!btn) return;

    // Ako smo na desktopu, ignoriši ovo dugme
    if (isDesktop()) return;

    applyFilters(1, false);
    lastAppliedFiltersState = getFiltersState();
    
    if (window.innerWidth < 768) {
      if (document.body.classList.contains("overflow-hidden")) {
        document.body.classList.remove("overflow-hidden");
      } else {
        document.body.classList.add("overflow-hidden");
      }
    }
  });

  // cancel mobile filters
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".filter-mob-cancel");
 
    if (!btn) return;

    if (isDesktop()) return;

    //restore filters on previously saved state
    restoreFiltersState(lastAppliedFiltersState);
    let closeMobileFiltersButton = document.querySelector(
      ".close-mobile-filters"
    );
    closeMobileFilters(closeMobileFiltersButton);
  });


  //load more filters. 4 shown as default. Click on button shows all
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".load-more-filters");
    if (!btn) return;

    const parent = btn.parentElement;
    if (!parent) return;

    const hiddenItems = parent.querySelectorAll(".collection-filter__hidden");
    hiddenItems.forEach((el) =>
      el.classList.remove("collection-filter__hidden")
    );

    //if mobile change parents max height because it is accordion
      if (window.innerWidth < 768) {
      // parent parent (accordion wrap)
      const accordion = parent.parentElement;
      if (accordion) {
        accordion.style.maxHeight = accordion.scrollHeight + "px";
      }
    }
    //hide button after expanding
    btn.style.display = "none";
  });


  // DOM Update - Render collection again
  async function applyFilters(page = 1, append = false) {
    //save curent state so you can add it to newly rendered section

    let applied_filters = document.querySelector('.applied-filters-span')?.textContent;
    let sort_text = document.querySelector('.sort-text')?.textContent;

    let loadMoreInnerText = document.querySelector("[data-load-more]");
    let desktopLayout = document.querySelector(".collection__products-wrapper");
    if (desktopLayout) {
      desktopLayout = desktopLayout.dataset.layout;
    }

    if (loadMoreInnerText) {
      let loadMoreSpan = loadMoreInnerText.querySelector(".loadmore-span");
      if (loadMoreSpan) {
        loadMoreInnerText = loadMoreSpan.textContent;
      } else {
        loadMoreInnerText = loadMoreInnerText.textContent;
      }
    }

  
    // section that you will render
    const section = document.querySelector(
      `[data-section-type="${sectionType}"]`
    );
    if (!section) return;

    //variables
    let container;
    let containerId;
    let sectionId;
    let params;
    let base;
    let fetchUrl;
    let qs;
    let json;
    let tmp;
    let incomingRoot;
    let newSection;

    //put is loading class
    section.classList.add("is-loading");

    if (sectionType == "search") {
      container = section.closest(".shopify-section") || section;
      containerId = container.getAttribute("id") || "";
      sectionId = containerId.startsWith("shopify-section-")
        ? containerId.replace("shopify-section-", "")
        : section.getAttribute("data-section-id") || "search";

      params = buildQueryParams(page) || new URLSearchParams();
      if (!params.get("page")) params.set("page", String(page));

      //if there is no Q in params, find the Q. This is actually the string term
      if (!params.get("q")) {
        const currentQ = new URL(location.href).searchParams.get("q");
        if (currentQ) params.set("q", currentQ);
      }
      if (!params.get("type")) params.set("type", "product");

      base = "/search";
      fetchUrl = `${base}?sections=${encodeURIComponent(sectionId)}${
        params.toString() ? `&${params.toString()}` : ""
      }`;
    } else {
      params = buildQueryParams(page);
      base = window.location.pathname;
      qs = params.toString();      
      fetchUrl = `${base}?sections=${sectionType}${qs ? `&${qs}` : ""}`;      
    }

    try {
      const res = await fetch(fetchUrl, {
        headers: { "X-Requested-With": "XMLHttpRequest" }, //optimized for shopify. Tells server that this is not page load but fetch json or part of html
        credentials: "same-origin", //add cookies in fetch so that shopify knows this is same session
      });
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      json = await res.json();
    } catch (err) {
      console.error("Filter AJAX error:", err);
      section.classList.remove("is-loading");
      return;
    }

    if (sectionType == "search") {
      const html = json?.[sectionId];
      if (!html) {
        console.warn("[filters] No HTML for section id:", sectionId, json);
        section.classList.remove("is-loading");
        return;
      }
      tmp = document.createElement("div");
      tmp.innerHTML = html;

      // 1) Replace ONLY inner HTML of the section root (preserve attributes/listeners on the node itself)
      if (!append) {
        incomingRoot =
          tmp.querySelector(`#shopify-section-${CSS.escape(sectionId)}`) ||
          tmp.firstElementChild;
        if (incomingRoot) {
          section.innerHTML = incomingRoot.innerHTML;
        }
      }
    } else {
      tmp = document.createElement("div");
      tmp.innerHTML = json[sectionType];

      // Replace ONLY inner content of <section>, preserving attributes
      if (!append) {
        newSection = tmp.querySelector(`[data-section-type="${sectionType}"]`);
        if (newSection) {
          section.innerHTML = newSection.innerHTML;
        }
      }
    }

    // Grid update (append or replace)
    const newGrid = tmp.querySelector("[data-product-grid]");
    const oldGrid = document.querySelector("[data-product-grid]");

    newGrid.classList.remove(
      "collection__layout-1",
      "collection__layout-2",
      "collection__layout-3"
    );

    if (newGrid && desktopLayout) {
      newGrid.dataset.layout = desktopLayout;
      newGrid.classList.add(`collection__layout-${desktopLayout}`);
    }

    if(applied_filters) {
      let new_applied_filter = document.querySelector('.applied-filters-span');
      new_applied_filter.textContent = applied_filters;      
    }

    if(sort_text) {
       let new_sort = document.querySelector('.sort-text');
      new_sort.textContent = sort_text;      
    }

    if (newGrid && oldGrid) {
      if (append) {
        oldGrid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
      } else {
        oldGrid.outerHTML = newGrid.outerHTML;
      }
    }
   

    // URL update on fresh filter/sort
    if (!append) {
      const qs = params.toString();
      const cleanQS = qs.replace(/(^|&)page=\d+(&|$)/, "$1");
      const newUrl = cleanQS ? `${base}?${cleanQS}` : base;
      history.replaceState(null, "", newUrl);
    }

    // Done
    const refreshed = document.querySelector(
      `[data-section-type="${sectionType}"]`
    );
    if (refreshed) refreshed.classList.remove("is-loading");
    addListenerOnAddToCartForm();
    renderAppliedFilters();
    handleDesktopLayout();
    handleMobileCloseFilters();
  }

  function renderAppliedFilters() {
    const container = document.querySelector(".collection__applied-filters");
    if (!container) return;

    // Find selected fitlers
    const selected = getSelectedFilters();

    // clear previous filters
    container.innerHTML = "";
    if (selected.length === 0) return;

    // create buttons for every filter
    selected.forEach((filter) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "g-btn g-btn--small g-btn--outline-tertiary-teal-green";
      btn.setAttribute(
        "aria-label",
        `Remove filter ${filter.label || filter.value}`
      );
      btn.setAttribute("data-value", filter.value);
      btn.setAttribute("data-name", filter.name);

      // text and close icon
      btn.innerHTML = `
      <span class="applied-filter-chip__text">${
        filter.label || filter.value
      }</span>
      <span class="applied-filter-chip__remove flex" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.19526 4.19526C4.45561 3.93491 4.87772 3.93491 5.13807 4.19526L8 7.05719L10.8619 4.19526C11.1223 3.93491 11.5444 3.93491 11.8047 4.19526C12.0651 4.45561 12.0651 4.87772 11.8047 5.13807L8.94281 8L11.8047 10.8619C12.0651 11.1223 12.0651 11.5444 11.8047 11.8047C11.5444 12.0651 11.1223 12.0651 10.8619 11.8047L8 8.94281L5.13807 11.8047C4.87772 12.0651 4.45561 12.0651 4.19526 11.8047C3.93491 11.5444 3.93491 11.1223 4.19526 10.8619L7.05719 8L4.19526 5.13807C3.93491 4.87772 3.93491 4.45561 4.19526 4.19526Z" fill="#8DB2A1"/>
      </svg>

      </span>
    `;

      // close removes filters
      btn.addEventListener("click", () => {
        const form = document.querySelector(".FiltersFormDesktop");
        if (!form) return;

        const name = btn.dataset.name;
        const value = btn.dataset.value;

        const selector = `input[type="checkbox"][name="${name}"][value="${value}"]`;
        const realInput = form.querySelector(selector);

        if (!realInput) return;

        realInput.checked = false;
        realInput.dispatchEvent(new Event("change", { bubbles: true }));
      });

      container.appendChild(btn);
    });
  }

  // Event listener for form product
  function addListenerOnAddToCartForm() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const formData = new FormData(form);
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        });

        if (!addRes.ok) {
          console.error("Add to cart failed");
          return;
        }

        const added = await addRes.json(); // ← single added line_item

        // 2) Update cart count (entire cart)
        const res = await fetch("/cart.js");
        const cart = await res.json();
        window.updateCartItemCounts(cart.item_count);

        // 3) Update cart drawer (your existing function)
        await window.updateCartDrawer();

        const qtyJustAdded = window.getAddedQuantityFromFormData(formData); // ← 1, or sum of items[n][quantity]

        // // 4) Fill cart-notification
        // window.fillCartNotification(added, qtyJustAdded);

        // // 5) Show notification (your existing function)
        // window.openCartNotification();
        window.openCartDrawer();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    renderAppliedFilters();
    handleDesktopLayout();
    handleMobileCloseFilters();
    lastAppliedFiltersState = getFiltersState();
  });
})();
